import React from "react";

function Header() {
  return (
    <div className="ui fixed menu">
      <div className="ui container centered" style={{width:"auto",textAlign:"center"}}>
        <h2>Contact Manager</h2>
      </div>
    </div>
  );
}

export default Header;
